import { render, staticRenderFns } from "./Puestos.vue?vue&type=template&id=24efa77f&"
import script from "./Puestos.vue?vue&type=script&lang=js&"
export * from "./Puestos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports